import { AddonELearningData } from '@/components/addons/elearning/Data';
import AddonModel from '@/models/grid/AddonModel';
import { AddonModelState } from '@/typings/interfaces/state/Addon';

interface AddonELearningState extends AddonModelState {
  alias: string; // Remove this line when implementing state
}

export class AddonELearningModel extends AddonModel<AddonELearningData, AddonELearningState> {
  parseAddon(data: AddonELearningData) {
    const state = this.state;
    // eslint-disable-next-line
    console.log('elearning', state, data);
  }

  authorSignature(): string {
    return 'Insert author here';
  }
}
